import Configs from '../account/constants/Configs';

export default class BasicVarAPI {
	static POST = (url, body, headers) => {
		return fetch(url, {
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json',
				'x-api-key': Configs.apiKey,
				...headers,
			},
			body: JSON.stringify(body),
		}).then(async (res) => {
			const response = await res.json();
			if (!res.ok || response.correlation_id) {
				throw response;
			}
			return response;
		});
	};
}
